import { render, staticRenderFns } from "./InOutHistoryCustomerRealtime.vue?vue&type=template&id=131cf45b"
import script from "./InOutHistoryCustomerRealtime.vue?vue&type=script&lang=js"
export * from "./InOutHistoryCustomerRealtime.vue?vue&type=script&lang=js"
import style0 from "./InOutHistoryCustomerRealtime.vue?vue&type=style&index=0&id=131cf45b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports